export const MOBILE_TYPES = {
  iOS: 'iOS',
  android: 'android',
  unknown: 'unknown',
}
